<h4 class="variant">
  {{ 'RECIPE_TRANSLATION.VARIANT' | translate }}:
  <span *ngFor="let variant of variants">
    <mat-icon svgIcon="ic_chef"></mat-icon>
    {{ variant }}
  </span>
</h4>
